import { Button, ConfigProvider, Divider, Dropdown, Popover, Segmented, Space } from "antd"
import { CheckOutlined } from '@ant-design/icons'
import { useMemo, useState } from "react"
import styles from "./index.module.scss"
import Iconfont from '@utils/Iconfont';

const TipContent = ({
    viewMode,
}) => {
    const items = viewMode == 1 ? [{
        title: "点击图片查看大图",
        content: "查看图片细节，确认交付质量",
    }, {
        title: "选择通过/不通过",
        content: "可以留下标注信息，能更好地理解需求",
    }, {
        title: "一组商品都审核完成后，点击【提交反馈】",
        content: "点击提交审核后，将进入后续流程",
    }] : [{
        title: "查看图片，选择通过/不通过",
        content: "如果选择不通过，请标注具体修改内容",
    }, {
        title: "对所有图片进行审核",
        content: "每张图片都需要反馈",
    }, {
        title: "点击【提交反馈】",
        content: "点击提交反馈，将进入后续流程",
    }]

    return (
        <div className={styles.TipContent}>
            <div className={styles.Title}>审核流程</div>
            <Divider />
            <div className={styles.ItemContainer}>
            {items.map((item, index) => (
                <div key={index} className={styles.Item}>
                    <span>{item.title}</span>
                    <span>{item.content}</span>
                </div>
            ))}
            </div>
        </div>
    )
}

const DeliveryDetailActions = ({
    viewMode,
    onViewModeChange,
    selectRowKeys,
    isMultiSelect,
    submitStatus,
    onDownload,
    onSubmit,
    onMultiSelect,
    onSelectAll,
    onMultiSubmit,
}) => {
    // 视图模式
    const viewModeOptions = useMemo(() => [{
        label: <span title="按商品排列">列表</span>,
        value: 1,
        icon: <Iconfont type="icon-view-row" style={{fontSize:16}} />,
    }, {
        label: <span title="大图平铺">大图</span>,
        value: 2,
        icon: <Iconfont type="icon-view-flat-big" style={{fontSize:16}} />,
    }, {
        label: <span title="小图平铺">小图</span>,
        value: 3,
        icon: <Iconfont type="icon-view-flat-small" style={{fontSize:16}} />,
    }], [])
    // 批量操作按钮
    const multiSelectOpts = useMemo(() => ([{
        label: '标记为通过',
        key: 'approve',
        btntext: '批量通过',
    }, {
        label: '标记为不通过',
        key: 'reject',
        btntext: '批量不通过',
    }, {
        label: '提交反馈',
        key: 'feedback',
        disabled: viewMode != 1,
        btntext: '批量提交反馈',
    }, {
        label: '下载',
        key: 'download',
        btntext: '批量下载',
    }]), [viewMode])
    // 批量操作按钮映射
    const multiSelectOptsMap = useMemo(() => multiSelectOpts.reduce((prev, cur) => {
        prev[cur.key] = cur
        return prev
    }, {}), [multiSelectOpts])
    const submitBtnNode = useMemo(() => {
        if (submitStatus == 'submitted') {
            return (
                <button className={styles.btn} disabled>
                    <CheckOutlined style={{fontSize:16}} />已提交
                </button>
            )
        }
        if (submitStatus == 'enabled') {
            return (
                <button className={`${styles.btn} ${styles.Primary}`} onClick={onSubmit}>
                    <Iconfont type="icon-delivery-submit" style={{fontSize:16}} />提交反馈
                </button>
            )
        }
        return (
            <Popover
                content={<span>请先标记批次内<strong>待验收</strong>图片是否通过</span>}
                placement='bottom'
                arrow={false}
            >
                <button className={styles.btn} disabled>
                    <Iconfont type="icon-delivery-submit" style={{fontSize:16}} />提交反馈
                </button>
            </Popover>
        )
    }, [submitStatus, onSubmit])

    if (!isMultiSelect) return (
        <Space size={12}>
            <Popover placement="bottomRight" arrow={false} content={<TipContent viewMode={viewMode} />}>
                <Iconfont type="icon-info" style={{fontSize:16}} />
            </Popover>
            <ConfigProvider
                theme={{
                    components: {
                        Segmented: {
                            itemSelectedColor: '#006EFF',
                            trackPadding: 4,
                        },
                    },
                }}
            >
                <Segmented
                    size="large"
                    options={viewModeOptions}
                    onChange={onViewModeChange}
                    value={viewMode}
                />
            </ConfigProvider>
            <Dropdown
                menu={{
                    items: multiSelectOpts,
                    onClick: (e) => {
                        onMultiSelect(e.key)
                    },
                }}
            >
                <button className={styles.btn}>批量操作</button>
            </Dropdown>
            <button className={styles.btn} onClick={e => onDownload()} >下载批次</button>
            {submitBtnNode}
        </Space>
    )
    else return (
        <Space size={8}>
        {
            viewMode == 1 ?
            <span style={{fontSize:14, lineHeight:20, color: "rgba(0, 0, 0, 0.5)"}}>已选商品：{selectRowKeys.length}组</span> :
            <span style={{fontSize:14, lineHeight:20, color: "rgba(0, 0, 0, 0.5)"}}>已选图片：{selectRowKeys.length}张</span>
        }
            <button key="all" className={styles.btn} onClick={onSelectAll}>全选</button>
            <button key="cancel" className={styles.btn} onClick={() => onMultiSelect(false)}>取消</button>
            <button key="feedback" className={`${styles.btn} ${styles.Primary}`} onClick={onMultiSubmit}>{multiSelectOptsMap[isMultiSelect]?.btntext || ''}</button>
        </Space>
    )
    
}

export default DeliveryDetailActions
